export default function ResumeData() {
  return [
    {
      id: 101,
      name: "Adobe Illustrator",
      description:
        "Adobe Illustrator is a powerful vector graphics editor used to create scalable designs such as logos, icons, and illustrations. It offers tools like the Pen tool and Shape Builder for precision and creative flexibility.",
      svgID: "symb-ai",
      category: "Design",
    },
    {
      id: 102,
      name: "Adobe Photoshop",
      description:
        "Adobe Photoshop is a raster graphics editor for image editing, photo manipulation, and digital painting. It provides advanced tools like layers, masks, and filters, making it ideal for photographers, designers, and artists.",
      svgID: "symb-psd",
      category: "Design",
    },
    {
      id: 103,
      name: "Adobe InDesign",
      description:
        "Adobe InDesign is a desktop publishing software used to design layouts for print and digital media. It excels at creating brochures, magazines, eBooks, and interactive PDFs with typography tools and grid systems.",
      svgID: "symb-inDesign",
      category: "Design",
    },
    {
      id: 104,
      name: "Adobe Premiere Pro",
      description:
        "Adobe Premiere Pro is a professional video editing software used to create high-quality videos. It supports multi-camera editing, color grading, and integration with other Adobe apps like After Effects for seamless workflows.",
      svgID: "symb-premiere",
      category: "Design",
    },
    {
      id: 105,
      name: "Adobe After Effects",
      description:
        "Adobe After Effects is an industry-standard compositing software. It enables users to create animations and motion graphics, primarily to create visual effects.",
      svgID: "symb-after_effects",
      category: "Design",
    },
    {
      id: 106,
      name: "Adobe Animate",
      description:
        "Adobe Animate is a multimedia authoring tool for creating animations and interactive content. It supports vector animations, character rigging, and export options for web platforms like HTML5 Canvas.",
      svgID: "symb-anim",
      category: "Design",
    },
    {
      id: 107,
      name: "Adobe XD",
      description:
        "Adobe XD is part of Adobe Creative Suite and is a deprecated software for creating wireframes, prototyping websites and planning UI Design. It allowed designers to collaborate in real-time and test interactive designs for web and mobile applications.",
      svgID: "symb-xd",
      category: "Design",
    },
    {
      id: 108,
      name: "Figma",
      description:
        "Figma is a cloud-based design and prototyping tool widely used for creating user interfaces (UI), user experiences (UX), and collaborative design workflows.",
      svgID: "symb-figma",
      category: "Design",
    },
    {
      id: 109,
      name: "Canva",
      description:
        "Canva is a versatile, cloud-based graphic design platform that simplifies the design process for users of all skill levels, primarily used for quick social media graphics",
      svgID: "symb-canva",
      category: "Design",
    },
    {
      id: 110,
      name: "Affinity Designer",
      description:
        "Affinity Designer is a professional-grade vector graphics editor developed by Serif. It offers a modern, intuitive interface, powerful tools for vector and raster design, and seamless switching between vector and pixel workspaces.",
      svgID: "symb-affinity",
      category: "Design",
    },
    {
      id: 201,
      name: "HTML",
      description:
        "HTML5 is the core markup language that structures web content using semantic elements like headings, paragraphs and media containers. It provides the essential framework for all websites and web applications.",
      svgID: "symb-html",
      category: "Development",
    },
    {
      id: 202,
      name: "CSS",
      description:
        "CSS (or Cascading Style Sheets) is the how we style every webpage to make it beautiful, unique, and intriguing.",
      svgID: "symb-css",
      category: "Development",
    },
    {
      id: 203,
      name: "Javascript",
      description:
        "Javascript is a scripting language that works in the browser to ensure functionality.",
      svgID: "symb-js",
      category: "Development",
    },
    {
      id: 204,
      name: "Pug.js",
      description:
        "Pug.js is a high-performance template engine for Node.js, designed to simplify HTML creation with a clean, indentation-based syntax.",
      svgID: "symb-pug",
      category: "Development",
    },
    {
      id: 205,
      name: "Sass",
      description:
        "SASS or SCSS is a popular CSS preprocessor that extends CSS capabilities by introducing features like variables, nesting, mixins, and functions. ",
      svgID: "symb-sass",
      category: "Development",
    },
    {
      id: 206,
      name: "React",
      description:
        "React is a JavaScript library created by Jordan Walke at Facebook in 2011 and open-sourced in 2013. It's used for building interactive web applications with reusable components, enhancing user interface responsiveness and efficiency.",
      svgID: "symb-react",
      category: "Development",
    },
    {
      id: 207,
      name: "Typescript",
      description:
        "TypeScript is a strongly typed programming language that builds on JavaScript by adding static typing, enabling developers to catch errors during development and write scalable, maintainable code. TypeScript compiles to JavaScript, making it compatible with any environment that supports JavaScript.",
      svgID: "symb-ts",
      category: "Development",
    },
    {
      id: 208,
      name: "Angular",
      description:
        "Angular is an open-source web application framework developed by Google in 2016. Built on TypeScript, it provides a component-based architecture for creating scalable single-page applications (SPAs) with features like two-way data binding and dependency injection.",
      svgID: "symb-angular",
      category: "Development",
    },
    {
      id: 209,
      name: "Node.js",
      description:
        "Node.js is an open-source runtime environment for executing JavaScript outside the browser, created by Ryan Dahl in 2009. Built on Chrome's V8 engine, it enables server-side scripting and is ideal for building scalable network applications due to its non-blocking, event-driven architecture.",
      svgID: "symb-node",
      category: "Development",
    },

    {
      id: 210,
      name: "Vite",
      description:
        "Vite is a modern build tool and development server created by Evan You in 2020. It is designed for fast front-end development, offering instant hot module replacement (HMR) and optimized builds for JavaScript frameworks like Vue and React.",
      svgID: "symb-vite",
      category: "Development",
    },
    {
      id: 211,
      name: "PHP",
      description:
        "PHP (Hypertext Preprocessor) is a server-side scripting language created by Rasmus Lerdorf in 1993. It is widely used for web development to generate dynamic content, interact with databases, and manage server-side functionality. PHP powers over 78% of websites globally and supports major operating systems and web servers.",
      svgID: "symb-php",
      category: "Development",
    },
    {
      id: 212,
      name: "Python",
      description:
        "Python is a high-level programming language created by Guido van Rossum in 1991. Known for its readability and versatility, Python is widely used in web development, data analysis, machine learning, and scripting across multiple platforms.",
      svgID: "symb-py",
      category: "Development",
    },
    {
      id: 301,
      name: "Wordpress",
      description:
        "WordPress is a free, open-source content management system (CMS) created in 2003 by Matt Mullenweg and Mike Little. It allows users to create, edit, and publish websites with customizable themes, plugins, and media management tools.",
      svgID: "symb-wp",
      category: "Tools",
    },
    {
      id: 302,
      name: "Visual Studio Code",
      description:
        "Visual Studio Code (VS Code) is a lightweight yet powerful source code editor developed by Microsoft in 2015. It supports multiple programming languages, offers built-in Git integration, debugging tools, IntelliSense for code completion, and an extensive ecosystem of extensions for customization.",
      svgID: "symb-vsc",
      category: "Tools",
    },
    {
      id: 303,
      name: "Github",
      description:
        "GitHub is a web-based platform for version control and collaboration created by Tom Preston-Werner, Chris Wanstrath, PJ Hyett, and Scott Chacon in 2008. Built on Git, it enables developers to host repositories, track changes, collaborate on projects, and manage workflows.",
      svgID: "symb-gh",
      category: "Tools",
    },
    {
      id: 304,
      name: "Git",
      description:
        "Git is a distributed version control system created by Linus Torvalds in 2005. It allows developers to track changes in files, collaborate on projects, and manage multiple branches of code independently. Git is known for its speed, data integrity, and ability to work offline, making it the most widely used tool for source code management in both open-source and commercial software development.",
      svgID: "symb-git",
      category: "Tools",
    },
    {
      id: 305,
      name: "CLI",
      description:
        "A Command Line Interface (CLI) is a text-based user interface that allows users to interact with a computer system by entering commands in a terminal or console. CLIs are favored by developers and system administrators for their speed, flexibility, and ability to automate tasks through scripting. Common examples include Bash, PowerShell, and cmd.exe",
      svgID: "symb-cli",
      category: "Tools",
    },
    {
      id: 306,
      name: "PostgreSQL",
      description:
        "PostgreSQL, often referred to as 'Postgres,' is an advanced open-source object-relational database management system (ORDBMS) created in 1986 at the University of California, Berkeley. It combines relational database features with object-oriented capabilities such as custom data types, table inheritance, and JSON support. PostgreSQL is widely used for data storage, analytics, and applications requiring complex data relationships.",
      svgID: "symb-postgres",
      category: "Tools",
    },
    {
      id: 307,
      name: "Supabase",
      description:
        "Supabase is an open-source backend-as-a-service platform launched in 2020; It provides a PostgreSQL database with real-time capabilities, authentication, auto-generated APIs, and scalable object storage, enabling developers to build modern applications quickly and efficiently.",
      svgID: "symb-supabase",
      category: "Tools",
    },
    {
      id: 308,
      name: "Firebase",
      description:
        "Firebase is a backend-as-a-service developed by Google in 2014. It offers real-time NoSQL databases, authentication, hosting, and cloud functions, making it ideal for building dynamic web and mobile applications without managing server infrastructure.",
      svgID: "symb-firebase",
      category: "Tools",
    },
    {
      id: 310,
      name: "MySQL",
      description:
        "MySQL is an open-source relational database management system (RDBMS) developed by Oracle Corporation. First released in 1995, it is known for its reliability, scalability, and ease of use. MySQL supports ACID transactions, replication, and multiple storage engines, making it a popular choice for web applications and enterprise solutions.",
      svgID: "symb-mysql",
      category: "Tools",
    },
    {
      id: 311,
      name: "Google Cloud",
      description:
        "Google Cloud Platform is a suite of cloud computing services offered by Google, launched in 2008. It provides tools for computing, storage, networking, machine learning, and big data analytics, enabling businesses to build scalable applications while leveraging Google’s global infrastructure.",
      svgID: "symb-gcloud",
      category: "Tools",
    },
    {
      id: 312,
      name: "AWS",
      description:
        "Amazon Web Services is a cloud computing platform created by Amazon in 2006. It offers over 200 services, including compute power, database storage, content delivery, and machine learning, with a pay-as-you-go pricing model. AWS is widely adopted for its scalability and reliability.",
      svgID: "symb-aws",
      category: "Tools",
    },
    {
      id: 313,
      name: "Cloudflare Workers",
      description:
        "Cloudflare Workers is a serverless computing platform introduced by Cloudflare in 2017. It allows developers to run JavaScript code at edge locations globally, enabling fast and scalable applications with reduced latency.",
      svgID: "symb-cloudflare-workers",
      category: "Tools",
    },
    {
      id: 314,
      name: "OpenAI API",
      description:
        "The OpenAI API provides access to advanced AI models like GPT-4 and DALL·E. Launched by OpenAI in 2020, it enables developers to integrate natural language processing, image generation, and other AI functionalities into their applications with a simple API interface.",
      svgID: "symb-openai",
      category: "Tools",
    },
  ];
}
